<template>
	<div class="chat-setting-c-container">
		<div class="chat-setting-c-title">缓存清理</div>
		<div class="chat-setting-c-box">
			<div class="chat-setting-c-item">
				<label>粉丝数据</label>
				<div class="chat-setting-c-input">
					<span :class="{'chat-setting-c-checked': clearList.indexOf('fans') !== -1}" @click="selectClearItem('fans')"></span>
				</div>
			</div>
			<div class="chat-setting-c-item">
				<label>聊天列表</label>
				<div class="chat-setting-c-input">
					<span :class="{'chat-setting-c-checked': clearList.indexOf('recently') !== -1}" @click="selectClearItem('recently')"></span>
				</div>
			</div>
			<div class="chat-setting-c-item">
				<label>聊天记录</label>
				<div class="chat-setting-c-input">
					<span :class="{'chat-setting-c-checked': clearList.indexOf('record') !== -1}" @click="selectClearItem('record')"></span>
				</div>
			</div>
			<div class="chat-setting-c-item">
				<label>粉丝标签</label>
				<div class="chat-setting-c-input">
					<span :class="{'chat-setting-c-checked': clearList.indexOf('tags') !== -1}" @click="selectClearItem('tags')"></span>
				</div>
			</div>
			<div class="chat-setting-c-item">
				<button @click="clearData" title="根据选项内容,清理对应的内容">立即清理</button>
				<button style="background-color: rgb(255, 95, 42);" @click="initData" title="特殊情况下,比如聊天异常,粉丝数据不匹配时使用">初始数据</button>
				<button style="background-color: #4c4a4a;" @click="clearOhter" title="图片上传失败情况下使用">清理缓存</button>
			</div>
		</div>
	</div>
</template>

<script>
	import {dropTable,clearTable} from '../../../network/local/setting.js'
	
	export default{
		name:'ChatSettingCache',
		data(){
			return{
				clearList:["recently"]
			}
		},
		methods:{
			// 清除选项选择
			selectClearItem(val){
				let index = this.clearList.indexOf(val)
				if(index === -1){
					this.clearList.push(val)
				}else{
					this.clearList.splice(index,1)
				}
			},
			
			// 清除数据-对应的选项
			clearData(){
				if(this.clearList.length === 0){
					CHAT_LAYER.msg('选项不能为空！',{icon: 2})
					return
				}
				window.chatDbLock = true
				CHAT_LAYER.open({type:3})
				clearTable(this.clearList,()=>{
					 window.chatDbLock = false
					 location.reload()
				})
			},
			
			// 清理缓存-清理其他的数据
			clearOhter(){
				window.localStorage.removeItem("yswl_oss")
				CHAT_LAYER.msg('清理缓存成功！',{icon: 1})
			},
			
			// 删除本地数据库
			initData(){
				window.chatDbLock = true
				CHAT_LAYER.open({type:3});
				dropTable(()=>{
					 window.chatDbLock = false
					 location.reload();
				})
			}
		}
	}
</script>

<style>
	.chat-setting-c-container{
		width: 100%;
		height: 100%;
		overflow-x: hidden;
		overflow-y: auto;
		position: relative;
	}
	.chat-setting-c-container .chat-setting-c-title{
		height: 50px;
		line-height: 50px;
		padding: 0 10px;
		border-bottom: 1px solid #d9d9d9;
	}
	.chat-setting-c-container .chat-setting-c-box{
		width: 100%;
		color: #666666;
	}
	.chat-setting-c-box .chat-setting-c-item{
		height: 40px;
		line-height: 40px;
		padding: 0 10px;
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}
	.chat-setting-c-item label{
		display: block;
		width: 70px;
	}
	.chat-setting-c-item .chat-setting-c-input{
		width: 200px;
		height: 40px;
	}
	.chat-setting-c-input span{
		display: block;
		width: 16px;
		height: 40px;
		background-position: center;
		background-repeat: no-repeat;
		background-size: 100% auto;
		background-image: url(../../../assets/img/select-out.png);
		cursor: pointer;
	}
	.chat-setting-c-input .chat-setting-c-checked{
		background-image: url(../../../assets/img/select-in.png) !important;
	}
	.chat-setting-c-item button{
		height: 24px;
		padding: 0 10px;
		color: #FFFFFF;
		background-color: #009688;
		border-radius: 2px;
		cursor: pointer;
		margin-right: 10px;
	}
</style>
